import React, { useState, useEffect } from "react";
import { FiInfo, FiAlertCircle, FiXCircle, FiX } from "react-icons/fi";

const Toast = ({ message, type, interval, position, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, interval - 300); // Start fading out 300ms before the interval ends

    return () => clearTimeout(timer);
  }, [interval]);

  useEffect(() => {
    if (!isVisible) {
      const closeTimer = setTimeout(onClose, 300); // Close after fade out
      return () => clearTimeout(closeTimer);
    }
  }, [isVisible, onClose]);

  const icons = {
    info: <FiInfo className="text-blue-400" />,
    warning: <FiAlertCircle className="text-yellow-400" />,
    error: <FiXCircle className="text-red-400" />,
  };

  const bgColors = {
    info: "bg-gray-800 border-blue-400",
    warning: "bg-gray-800 border-yellow-400",
    error: "bg-gray-800 border-red-400",
  };

  return (
    <div
      className={`fixed ${position === "center" ? "top-1/2" : "top-4"} left-1/2 
        transform -translate-x-1/2 ${
          position === "center" ? "-translate-y-1/2" : ""
        } 
        z-[10001] transition-opacity duration-300 ease-in-out ${
          isVisible ? "opacity-100" : "opacity-0"
        }`}
    >
      <div
        className={`flex items-center p-4 rounded-lg shadow-lg border ${bgColors[type]}`}
      >
        <div className="flex-shrink-0 mr-3">{icons[type]}</div>
        <div className="text-sm font-medium text-gray-200">{message}</div>
        <button
          onClick={() => setIsVisible(false)}
          className="ml-4 text-gray-400 hover:text-gray-200"
        >
          <FiX />
        </button>
      </div>
    </div>
  );
};

export default Toast;
